module.exports = __webpack_public_path__ + "static/img/fullscreen-image_lets-get.251e509.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/surveys/fullscreen-image_lets-get.png
// module id = Dshs
// module chunks = 0